import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbRespAppliedFilters } from '../SbRespAppliedFilters/SbRespAppliedFilters';
import { sbRespRefineMenuFiltersMap } from './SbRespRefineMenuFilters/sbRespRefineMenuFiltersMap';
import { SbSharedRefineMenuFilters } from '../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilters';
import { SbSharedRefineMenuDisplayPrefsSelect } from '../SbSharedRefineMenu/SbSharedRefineMenuDisplayPrefsSelect/SbSharedRefineMenuDisplayPrefsSelect';

const SbRespRefineMenuComponent = ({
    viewer,
    user,
    filters,
    isClient,
    currency,
    itemSearch,
    uriRef,
    isTrade,
}) => {
    const { isSbSharedRefineMenuDisplayPrefsSelectEnabled } = viewer;

    return (
        <React.Fragment>
            <SbRespAppliedFilters
                user={user}
                viewer={viewer}
                currency={currency}
                itemSearch={itemSearch}
            />
            <SbSharedRefineMenuFilters
                user={user}
                uriRef={uriRef}
                viewer={viewer}
                filters={filters}
                currency={currency}
                isClient={isClient}
                itemSearch={itemSearch}
                filterMap={sbRespRefineMenuFiltersMap}
                initiallyExpanded={filterName =>
                    filterName.includes('category') ||
                    filterName.includes('price') ||
                    filterName.includes('item_type')
                }
                isTrade={isTrade}
            />
            {isSbSharedRefineMenuDisplayPrefsSelectEnabled && (
                <SbSharedRefineMenuDisplayPrefsSelect
                    user={user}
                    filters={filters}
                    itemSearch={itemSearch}
                />
            )}
        </React.Fragment>
    );
};

SbRespRefineMenuComponent.propTypes = {
    isClient: PropTypes.bool,
    viewer: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    itemSearch: PropTypes.object.isRequired,
    user: PropTypes.object,
    uriRef: PropTypes.string,
    isTrade: PropTypes.bool,
};

export const SbRespRefineMenu = createFragmentContainer(SbRespRefineMenuComponent, {
    viewer: graphql`
        fragment SbRespRefineMenu_viewer on Viewer {
            ...SbRespAppliedFilters_viewer
            ...SbSharedRefineMenuFilters_viewer
            isDeliveryOptionsDisabled: isEnabledByLocale(
                featureName: "DISABLE_SB_DELIVERY_OPTION_FILTERS"
            )
            isSbSharedRefineMenuDisplayPrefsSelectEnabled: isEnabledByLocale(
                featureName: "NON_MVP_SEARCH_BROWSE"
            )
        }
    `,
    itemSearch: graphql`
        fragment SbRespRefineMenu_itemSearch on ItemSearchQueryConnection {
            topCategoryL1
            ...SbRespAppliedFilters_itemSearch
            ...SbSharedRefineMenuFilters_itemSearch
            ...SbSharedRefineMenuDisplayPrefsSelect_itemSearch
        }
    `,
    filters: graphql`
        fragment SbRespRefineMenu_filters on SearchBrowseFilter @relay(plural: true) {
            ...SbSharedRefineMenuFilters_filters
            ...SbSharedRefineMenuDisplayPrefsSelect_filters
        }
    `,
    user: graphql`
        fragment SbRespRefineMenu_user on User {
            ...SbRespAppliedFilters_user
            ...SbSharedRefineMenuFilters_user
            ...SbSharedRefineMenuDisplayPrefsSelect_user
        }
    `,
});
